"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _propTypes = require("prop-types");

var _PhotoUploader = require("./PhotoUploader.styles");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _avatar_default = _interopRequireDefault(require("../../assets/images/avatar_default.png"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getDefaultPicAsPhoto = function getDefaultPicAsPhoto(pic) {
  return typeof pic === 'string' ? pic : '';
};

var menu = function menu(data) {
  return (0, _jsxRuntime.jsx)(_Dropdown["default"].Menu, {
    children: data.map(function (_ref) {
      var title = _ref.title,
          key = _ref.key;
      return (0, _jsxRuntime.jsx)(_Dropdown["default"].Menu.Item, {
        itemKey: key,
        children: title
      }, key);
    })
  });
};

var PhotoUploader = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var defaultPicture = _ref2.defaultPicture,
      picture = _ref2.picture,
      onUpload = _ref2.onUpload,
      onRemove = _ref2.onRemove,
      className = _ref2.className,
      hint = _ref2.hint,
      type = _ref2.type;

  var _useState = (0, _react.useState)(function () {
    return (// Don't show defaultPicture as the photo if it's a svg element
      getDefaultPicAsPhoto(defaultPicture)
    );
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      photo = _useState2[0],
      setPhoto = _useState2[1];

  (0, _react.useEffect)(function () {
    if (picture) {
      setPhoto(picture);
    }
  }, [picture]);
  var menuList = (0, _react.useMemo)(function () {
    return [{
      key: 'upload',
      title: "Upload ".concat(type)
    }, {
      key: 'remove',
      title: "Remove ".concat(type)
    }];
  }, [type]);
  var getMenu = (0, _react.useCallback)(function (noRemove) {
    if (noRemove) {
      return menuList.filter(function (item) {
        return item.key !== 'remove';
      });
    }

    return menuList;
  }, [menuList]);

  var _useState3 = (0, _react.useState)(getMenu(!picture)),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      list = _useState4[0],
      setList = _useState4[1]; // Handle getting uploaded phto


  var handleDrop = (0, _react.useCallback)(function (files) {
    if (!files.length) return;
    var file = files[0];
    onUpload(file);
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      return setPhoto(reader.result);
    }, false);
    reader.readAsDataURL(file);
    setList(getMenu());
  }, [getMenu, onUpload]);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    noClick: true,
    // click button to trigger open, so noClick for container
    noDrag: true,
    // no drag & drap, click dropdown's button to upload
    multiple: false,
    // only allow to choose one file
    maxSize: 2097152,
    // 2mb
    accept: 'image/jpg,image/jpeg,image/png',
    // jpg and png
    onDropAccepted: handleDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      open = _useDropzone.open,
      inputRef = _useDropzone.inputRef;

  var handleSelect = (0, _react.useCallback)(function (key) {
    if (key === 'remove') {
      // Remove photo
      setPhoto(getDefaultPicAsPhoto(defaultPicture));
      setList(getMenu(true));
      onRemove();
    } else if (key === 'upload') {
      open();
    }
  }, [defaultPicture, getMenu, onRemove, open]); // Pass inputRef to ref

  (0, _react.useEffect)(function () {
    if (!ref) return;

    if (typeof ref === 'function') {
      ref(inputRef);
    } else if ((0, _typeof2["default"])(ref) === 'object') {
      Object.assign(ref, inputRef);
    }
  }, [inputRef, ref]);
  return (0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    css: _PhotoUploader.styles.imgBox,
    className: className,
    style: {
      backgroundImage: "url(".concat(photo, ")")
    }
  }, getRootProps()), {}, {
    children: [!photo && (0, _jsxRuntime.jsx)("div", {
      css: _PhotoUploader.styles.defaultPictureWrapper,
      children: defaultPicture
    }), (0, _jsxRuntime.jsx)("input", _objectSpread({
      className: "grui",
      css: _elements.input.styles.preflight
    }, getInputProps())), (0, _jsxRuntime.jsx)(_Dropdown["default"], {
      overlay: menu(list),
      css: _PhotoUploader.styles.dropdown,
      onSelect: handleSelect,
      children: (0, _jsxRuntime.jsxs)("button", {
        className: "grui",
        css: _elements.button.styles.preflight,
        type: "button",
        children: [(0, _jsxRuntime.jsx)(_icons.Camera, {}), (0, _jsxRuntime.jsx)("div", {
          children: hint
        })]
      })
    })]
  }));
});

PhotoUploader.propTypes = {
  // Photo from database
  picture: _propTypes.string,

  /**
   * Callback for when user upload file to the file input;
   * file as an argument
   */
  onUpload: _propTypes.func,
  onRemove: _propTypes.func,
  className: _propTypes.string,
  hint: _propTypes.string,

  /**
   * For dropdown items
   */
  type: _propTypes.string,

  /**
   * Showing this picture when there's no picture
   * accept svg or img
   */
  defaultPicture: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
PhotoUploader.defaultProps = {
  picture: undefined,
  onUpload: function onUpload() {},
  onRemove: function onRemove() {},
  className: undefined,
  hint: 'Change your profile picture.',
  type: 'picture',
  defaultPicture: _avatar_default["default"]
};
PhotoUploader.displayName = 'PhotoUploader';
var _default = PhotoUploader;
exports["default"] = _default;
//# sourceMappingURL=PhotoUploader.js.map